var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZeroState = function SvgZeroState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Zero_State_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Zero_State_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: -1.875,
    width: 26.25,
    height: 32.813,
    rx: 2,
    fill: "#E3D4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.438 21.328h16.406M8.438 16.172h16.406M8.438 11.016h16.406M8.438 5.86h16.406M8.438 26.484H22.03",
    stroke: "#A79378",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.963 17.207s5.773-2.765 8.98-3.145c3.207-.379 9.682.938 9.682.938v16.562a5 5 0 0 1-5 5H15s-2.271-6.416-1.891-10.162c.38-3.747 3.854-9.193 3.854-9.193Z",
    fill: "#E3D4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 28.36h10.781M15.938 20.86H29.53",
    stroke: "#A79378",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 57.813,
    cy: 30.938,
    fill: "#000",
    r: 18.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.276,
    cy: 28.745,
    transform: "rotate(-45 28.276 28.745)",
    fill: "#fff",
    fillOpacity: 0.24,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.344 16.812c-6.59 6.59-6.59 17.275 0 23.865 6.142 6.142 15.84 6.56 22.466 1.253l6.039 6.04 2.652-2.652-6.04-6.04c5.307-6.625 4.89-16.324-1.252-22.466-6.59-6.59-17.275-6.59-23.865 0Zm2.651 2.652c5.126-5.126 13.436-5.126 18.562 0 5.125 5.126 5.125 13.436 0 18.561-5.126 5.126-13.436 5.126-18.562 0-5.125-5.125-5.125-13.435 0-18.561Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.534,
    y: 48.632,
    width: 9.375,
    height: 16.875,
    rx: 4,
    transform: "rotate(-45 41.534 48.632)",
    fill: "#7D6E5A"
  }))));
};
export default SvgZeroState;